export default __webpack_public_path__ + "static/media/blog5.5de896e1.png";